var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 4,
    fill: "#0066B0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12342_24942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 11.75C7.7625 11.75 6.75 12.7625 6.75 14C6.75 15.2375 7.7625 16.25 9 16.25C10.2375 16.25 11.25 15.2375 11.25 14C11.25 12.7625 10.2375 11.75 9 11.75ZM9 15.5C8.175 15.5 7.5 14.825 7.5 14C7.5 13.175 8.175 12.5 9 12.5C9.825 12.5 10.5 13.175 10.5 14C10.5 14.825 9.825 15.5 9 15.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 14H16.5C16.5 9.875 13.125 6.5 9 6.5V5.75C13.5375 5.75 17.25 9.4625 17.25 14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 14H13.5C13.5 11.525 11.475 9.5 9 9.5V8.75C11.8875 8.75 14.25 11.1125 14.25 14Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12342_24942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsBlue);
export default __webpack_public_path__ + "static/media/NewsBlue.797468d81ab875b3fa20ee8e3192a343.svg";
export { ForwardRef as ReactComponent };